import { createSlice } from "@reduxjs/toolkit";

export const addUserFeeSlice = createSlice({
  name: "addUserFee",
  initialState: {
    lockerTypeAndUserType: {
      lockerTypeId: "-1",
      userTypeId: "-1",
    },
    lockerUserTypesList: [],
    lockerTypesList: [],
    doorSizesList: [],
    // For Pickup
    addDataItem: [],
    // For Shipout
    addShipoutData: [],
  },
  reducers: {
    handleChangeLockerTypeAndUserTypeReducer: (state, actions) => {
      const { name, value } = actions.payload;
      const tempVar = { ...state.lockerTypeAndUserType };
      tempVar[name] = value;
      // Lists
      const tempData = [...state.addDataItem];
      const tempShipoutData = [...state.addShipoutData];

      tempData.forEach((element, index) => {
        tempData[index][name] = value;
      });
      tempShipoutData.forEach((element, index) => {
        tempShipoutData[index][name] = value;
      });
      state.lockerTypeAndUserType = tempVar;
      state.addDataItem = tempData;
      state.addShipoutData = tempShipoutData;
    },
    // setLockerUserTypeList: (state, actions) => {
    //   state.lockerUserTypesList = actions.payload;
    // },
    setLockerUserTypeList: (state, actions) => {
      state.lockerUserTypesList = actions.payload
        .filter((element) => {
          return !(
            element.partnerDropoffFees?.length > 0 ||
            element.partnerShipoutFees?.length > 0
          );
        })
        .map((element) => ({
          value: element.userTypeId,
          name: element.userType,
        }));
    },
    setLockerTypeList: (state, actions) => {
      state.lockerTypesList = actions.payload;
    },
    setDoorSizesList: (state, actions) => {
      state.doorSizesList = actions.payload;
    },
    //For Pickup
    handleAddDataItemReducer: (state, actions) => {
      let tempVar = [...state.addDataItem];
      tempVar.push(actions.payload);
      state.addDataItem = tempVar;
    },
    handleEditAddedDataReducer: (state, actions) => {
      const { name, value, id } = actions.payload;
      const tempVar = [...state.addDataItem];
      if (id && name) {
        if (
          name === "initialFee" ||
          name === "excessFeePerInc" ||
          name === "maxOverstayCharge"
        ) {
          if (parseFloat(value) >= 0 && parseFloat(value) <= 1000000000.0) {
            tempVar[id][name] = parseFloat(value).toFixed(2);
          } else if (value === "") {
            tempVar[id][name] = value;
          }
        } else if (name === "incByHours") {
          if (value >= 0 && value <= 720) {
            tempVar[id][name] = value;
          }
        } else if (name === "addInitialFreeHours") {
          if (value >= 1 && value <= 720) {
            tempVar[id][name] = value;
          }
        } else {
          tempVar[id][name] = value;
        }
      }
    },
    // For Shipout
    handleShipoutAddDataItemReducer: (state, actions) => {
      let tempVar = [...state.addShipoutData];
      tempVar.push(actions.payload);
      state.addShipoutData = tempVar;
    },
    handleShipoutEditAddedDataReducer: (state, actions) => {
      const { name, value, id } = actions.payload;
      const tempVar = [...state.addShipoutData];
      if (id && name) {
        if (
          name === "initialReturnFee" ||
          name === "excessFeePerInc" ||
          name === "maxOverstayCharge"
        ) {
          if (parseFloat(value) >= 0 && parseFloat(value) <= 1000000000.0) {
            tempVar[id][name] = parseFloat(value).toFixed(2);
          } else if (value === "") {
            tempVar[id][name] = value;
          }
        } else if (name === "incByHours") {
          if (value >= 0 && value <= 720) {
            tempVar[id][name] = value;
          }
        } else if (name === "addInitialFreeHours") {
          if (value >= 1 && value <= 720) {
            tempVar[id][name] = value;
          }
        } else {
          tempVar[id][name] = value;
        }
      }
    },
    handelCancelChagesReducer: (state) => {
      state.lockerTypeAndUserType = {
        lockerTypeId: "-1",
        userTypeId: "-1",
      };
      // For Pickup
      state.addDataItem = [];
      // For Shipout
      state.addShipoutData = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  handleAddDataItemReducer,
  setLockerUserTypeList,
  setLockerTypeList,
  handleChangeLockerTypeAndUserTypeReducer,
  handleEditAddedDataReducer,
  setDoorSizesList,
  handleShipoutAddDataItemReducer,
  handleShipoutEditAddedDataReducer,
  handelCancelChagesReducer,
} = addUserFeeSlice.actions;

export default addUserFeeSlice.reducer;
